export default {
    "enabled": {
        "ui:title": "Søk"
    }
}